<template>
	<div class="about">
		<div class="pg-header">
			<div>
				<label class="title" v-if="filter.dictId == 99">问卷看板</label>
				<label class="title" v-else>问卷汇总</label>

			</div>
			<div class="algr">
				<div class="pg-nav">
					<i class="icon-home"></i>
					<span>统计管理</span>|
					<span>问卷统计</span>|
					<span v-if="filter.dictId == 99">问卷看板</span>
					<span v-else>问卷汇总</span>
				</div>
			</div>
		</div>

		<div class="collapse-wrap">
			<div class="search-bar">
				<el-form ref="form" label-width="120px">
					<div class="def-key">
						<div style="display: inline-block;" v-if="filter.dictId != 99">问卷名称
							<el-select size="small" filterable clearable v-model="filter.dictId" placeholder="请选择"
								@change="handleFilter(1, $event)">
								<el-option v-for="item in questList" :key="item.id" :label="item.name"
									:value="item.id"></el-option>
							</el-select>
						</div>
						<label>填写日期
							<el-date-picker size="small" :default-time="['00:00:00', '23:59:59']" style="width:220px"
								type="daterange" align="right" unlink-panels range-separator="至"
								start-placeholder="开始日期" end-placeholder="结束日期" v-model="filter.finishdate"
								:picker-options="pickerOptions" @change="handleFilter(3, $event)"></el-date-picker>
						</label>
						<label>{{ timeLabel[dataSources] }}
							<el-date-picker size="small" :default-time="['00:00:00', '23:59:59']" style="width:220px"
								type="daterange" align="right" unlink-panels range-separator="至"
								start-placeholder="开始日期" end-placeholder="结束日期" v-model="filter.date"
								:picker-options="pickerOptions" @change="handleFilter(0, $event)"></el-date-picker>
						</label>
						<div style="display: inline-block;">科室
							<el-select size="small" filterable clearable v-model="filter.depId" placeholder="请选择"
								@change="handleFilter(1, $event)">
								<el-option v-for="item in deptList" :key="item.id" :label="item.name"
									:value="item.id"></el-option>
							</el-select>
						</div>
						<div style="display: inline-block;" v-if="filter.dictId != 99">机构
							<el-select size="small" filterable clearable v-model="filter.orgId" placeholder="请选择"
								@change="handleFilter(1, $event)">
								<el-option v-for="item in orgList" :key="item.id" :label="item.name"
									:value="item.id"></el-option>
							</el-select>
						</div>
						<el-button size="mini" icon="el-icon-search" round
							@click="handleFilter(4, $event)">搜索</el-button>
						<el-button class="btn-export flr" size="mini" round @click="exportExcel"><i class="icon-export"
								style="margin-right: 10px;"></i>导出</el-button>
					</div>
				</el-form>
			</div>

			<div class="table-wrap">
				<el-table ref="multipleTable" header-cell-class-name="tab-cell" cell-class-name="tab-cell" border
					:data="list.data" v-loading="isLoading">

					<el-table-column label="科室" width="180">
						<template slot-scope="scope">{{ scope.row.depName }}</template>
					</el-table-column>
					<template v-if="filter.dictId == 99">
						<el-table-column v-for="item in questionInfo" :key="item.id" width="180" show-overflow-tooltip>
							<!-- 自定义表头，支持点击跳转 -->
							<template slot="header">
								<span class="clickable-header" @click="handleHeaderClick(item)" :title="item.name">
									{{ item.name }}
								</span>
							</template>
							<!-- 表格内容 -->
							<template slot-scope="scope">
								<span style='cursor:pointer;' @click="handleColumnClick(scope.row, item)">
									{{ list.total > 0 ? scope.row[item.id] ? scope.row[item.id] : 0 : '' }}
								</span>
							</template>
						</el-table-column>
					</template>
					<template v-else>
						<el-table-column v-for="item in questionInfo.formItems" :label="item.label" :key="item.formId"
							:width="getColumnWidth(item)" show-overflow-tooltip>
							<el-table-column v-for="option in item.options" :label="option.label" :key="option.value"
								:width="getSubColumnWidth(item)">
								<template slot-scope="scope">
									{{scope.row[item.formId]?.find(opt => opt.value === option.value).count}}
								</template>
							</el-table-column>
						</el-table-column>
					</template>
					<template #empty>
						<div style="text-align: center;">
							<p style="font-size:16px;color:#699CE4;">暂无数据，请【选择问卷】后进行查看</p>
						</div>
					</template>
				</el-table>
				<div class="pagination">
					<el-row>
						<el-col :span="12">
							<div class="record">当前是第<span
									v-text="(filter.pageNumber - 1) * filter.pageSize + 1"></span>条至第<span
									v-text="Math.min(list.total, (filter.pageNumber - 1) * filter.pageSize + filter.pageSize)"></span>数据
							</div>
							<div class="record">总计<span v-text="list.total"></span>条记录</div>
						</el-col>
						<el-col :span="12" style="text-align: right;">
							<el-pagination :disabled="isLoading" layout="sizes, prev, pager, next"
								:page-sizes="[10, 20, 30, 40, 50, 60, 70, 80, 90, 100]" prev-text="上一页" next-text="下一页"
								:current-page="list.current" :page-size="filter.pageSize" :total="list.total"
								@size-change="handleSizeChange" @current-change="handleCurrentChange"></el-pagination>
						</el-col>
					</el-row>
				</div>
				<div style="display: none;">
					<el-table ref="multipleTable2" header-cell-class-name="tab-cell" cell-class-name="tab-cell" border
						:data="list2.data" v-loading="isLoading">
						<el-table-column label="科室" width="180">
							<template slot-scope="scope">{{ scope.row.depName }}</template>
						</el-table-column>
						<el-table-column v-for="item in questionInfo.formItems" :label="item.label" :key="item.formId"
							width="180" show-overflow-tooltip>
							<el-table-column v-for="option in item.options" :label="option.label" :key="option.value">
								<template slot-scope="scope">
									{{scope.row[item.formId].find(opt => opt.value === option.value).count}}
								</template>
							</el-table-column>
						</el-table-column>
					</el-table>
				</div>

			</div>
			<div style="display: none;">
				<el-table ref="multipleTable2" header-cell-class-name="tab-cell" cell-class-name="tab-cell" border
					:data="list2.data" v-loading="isLoading">
					<el-table-column label="科室" width="180">
						<template slot-scope="scope">{{ scope.row.depName }}</template>
					</el-table-column>
					<template v-if="filter.dictId == 99">
						<el-table-column v-for="item in questionInfo" :label="item.name" :key="item.id" width="180"
							show-overflow-tooltip>
							<template slot-scope="scope">
								{{ list.total > 0 ? scope.row[item.id] ? scope.row[item.id] : 0 : '' }}
							</template>
						</el-table-column>
					</template>
					<template v-else>
						<el-table-column v-for="item in questionInfo.formItems" :label="item.label" :key="item.formId"
							width="180" show-overflow-tooltip>
							<el-table-column v-for="option in item.options" :label="option.label" :key="option.value">
								<template slot-scope="scope">
									{{scope.row[item.formId]?.find(opt => opt.value === option.value).count}}
								</template>
							</el-table-column>
						</el-table-column>
					</template>
				</el-table>
			</div>
		</div>

	</div>
</template>

<script>
import api from '@/service/api.js';
import mixin from '@/views/mixin';
import dayjs from 'dayjs';
import utils from '@/service/utils.js'

export default {
	mixins: [mixin],
	data() {
		return {
			list: {
				current: 1,
				total: 0,
				pageSize: 0,
				data: []
			},
			filter: {
				hospitalTimeStart: '',
				hospitalTimeEnd: '',
				depId: '',
				orgId: '',
				pageNumber: 1,
				pageSize: 10,
				dictId: '',
				finishdate: [],
				finishTimeStart: '',
				finishTimeEnd: '',
				date: []
			},
			list2: {
				current: 1,
				total: 0,
				pageSize: 0,
				data: []
			},
			deptList: [],
			questionInfo: {},
			permission: false,
			orgList: [],
			questList: [],
			dataSources: 2,
			timeLabel: {
				0: '入院日期',
				1: '就诊日期',
				2: '出院日期'
			}
		}
	},
	watch: {
		'$route.query': {
			handler(newQuery, oldQuery) {
				if (!oldQuery) return;

				const keyParams = ['dictId', 'datasources', 'depId'];

				const finishdateChanged = JSON.stringify(newQuery.finishdate) !== JSON.stringify(oldQuery.finishdate);
				const dateChanged = JSON.stringify(newQuery.date) !== JSON.stringify(oldQuery.date);
				const hasKeyChange = keyParams.some(key => newQuery[key] !== oldQuery[key]) || finishdateChanged || dateChanged;

				if (hasKeyChange) {
					this.initializeFromQuery(newQuery);

					
				}
			},
			immediate: false
		}
	},

	created() {
		this.initializeFromQuery(this.$route.query);

		
		this.loadDropdownData();
	},

	methods: {
		initializeFromQuery(query) {
			// 重置所有筛选条件
			this.filter.dictId = query.dictId ? +query.dictId : '';
			this.filter.depId = query.depId || '';
			this.filter.orgId = query.orgId || '';
			this.filter.pageNumber = 1;
			this.dataSources = query.datasources !== undefined ? +query.datasources : 2;

			// 如果没有日期参数，清空日期相关字段
			if (!query.finishdate && !query.date) {
				this.filter.finishdate = [];
				this.filter.finishTimeStart = '';
				this.filter.finishTimeEnd = '';
				this.filter.date = [];
				this.filter.hospitalTimeStart = '';
				this.filter.hospitalTimeEnd = '';
			}
			if (query.finishdate || query.date||(query.dictId&&query.dictId!=99)) {
				this.handleDateParams(query);
			} else {
				this.setTime();
			}
		},
		handleDateParams(query) {
			// 处理填写日期参数
			if (query.finishdate) {
				const dates = query.finishdate.split(',');
				if (dates.length === 2) {
					this.filter.finishTimeStart = dayjs(dates[0]).format('YYYY-MM-DD 00:00:00');
					this.filter.finishTimeEnd = dayjs(dates[1]).format('YYYY-MM-DD 23:59:59');
					this.filter.finishdate = [
						new Date(dates[0]),
						new Date(dates[1])
					];
				}
			}

			// 处理出院日期参数
			if (query.date) {
				const dates = query.date.split(',');
				if (dates.length === 2) {
					this.filter.hospitalTimeStart = dayjs(dates[0]).format('YYYY-MM-DD 00:00:00');
					this.filter.hospitalTimeEnd = dayjs(dates[1]).format('YYYY-MM-DD 23:59:59');
					this.filter.date = [
						new Date(dates[0]),
						new Date(dates[1])
					];
				}
			}

			this.loadList();
		},

		// 加载下拉数据
		async loadDropdownData() {
			try {
				const [deptRes, orgRes, questRes] = await Promise.all([
					api.getDeptDropdown(),
					api.getListComboboxOrg(),
					api.getComboboxQuestionnaire()
				]);

				if (deptRes.code === 1000 && deptRes.data) {
					this.deptList = deptRes.data;
				}

				if (orgRes.code === 1000) {
					this.orgList = orgRes.data;
				}
				if (questRes.code === 1000) {
					this.questList = questRes.data;
					let obj=questRes.data.find(item=>item.id==18);
				}
				else {
					this.$message.error(orgRes.message);
				}
			} catch (error) {
				console.error('加载下拉数据失败:', error);
				this.$message.error('加载下拉数据失败');
			}
		},
		// 设置默认时间
		setTime() {
			if (!this.$route.query.finishdate && !this.$route.query.date) {
				const now = dayjs();
				const firstDayOfMonth = dayjs().startOf('month');
				this.filter.finishTimeStart = firstDayOfMonth.format('YYYY-MM-DD HH:mm:ss');
				this.filter.finishTimeEnd = now.format('YYYY-MM-DD HH:mm:ss');
				this.filter.finishdate = [this.filter.finishTimeStart, this.filter.finishTimeEnd];
			}
			this.loadList();
		},
		async loadList() {
			this.isLoading = true;

			if (!this.filter.dictId) {
				this.resetEmptyState();
				return;
			}

			try {
				const res = await this.fetchData();

				if (res.code === 500) {
					return this.$router.push({
						name: 'Login',
						query: { r: location.href }
					});
				}

				if (res.code !== 1000) {
					this.$message.error(res.message);
					return;
				}

				this.updateListData(res);
				this.updatePermission();
			} catch (error) {
				console.error('加载数据失败:', error);
				this.$message.error('加载数据失败');
			} finally {
				this.isLoading = false;
			}
		},

		resetEmptyState() {
			this.list = {
				total: 0,
				current: 1,
				pageSize: 0,
				data: []
			};
			this.questionInfo = {
				formItems: [
					{
						formId: "emptyCount",
						options: [{ label: "合计" }],
						label: "问卷总数",
						dId: "emptyCount",
						width: 180
					},
					{
						formId: "emptyques",
						options: [],
						typeId: "empty",
						label: "问卷题目",
						dId: "1",
						width: 'auto'
					}
				]
			};
			this.isLoading = false;
		},

		async fetchData() {
			if (this.filter.dictId == 99) {
				// 问卷看板模式
				const params = {
					pageSize: this.filter.pageSize,
					pageNumber: this.filter.pageNumber,
					finishTimeStart: this.filter.finishTimeStart,
					finishTimeEnd: this.filter.finishTimeEnd,
					finishdate: [this.filter.finishTimeStart, this.filter.finishTimeEnd],
					hospitalTimeStart: this.filter.hospitalTimeStart,
					hospitalTimeEnd: this.filter.hospitalTimeEnd,
					date: [this.filter.hospitalTimeStart, this.filter.hospitalTimeEnd],
					depIds: this.filter.depId
				};
				return await api.getQuestionnaireFollowup(params);
			} else {
				// 问卷汇总模式
				return await api.getQuestionnaireGather(this.filter);
			}
		},

		updateListData(res) {
			this.list.total = +res.total;
			this.list.current = this.filter.pageNumber;
			this.list.pageSize = Math.ceil(this.list.total / this.filter.pageSize);
			this.list.data = this.sortDataWithSummary(res.data.formResults);
			this.questionInfo = res.data.formItems;
		},

		sortDataWithSummary(data) {
			if (data.length <= 1) return data;

			// 将合计行（depId为0）移到最后
			const summaryItem = data.find(item => item.depId === 0);
			const dataItems = data.filter(item => item.depId !== 0);

			return summaryItem ? [...dataItems, summaryItem] : dataItems;
		},

		updatePermission() {
			const user = JSON.parse(localStorage.getItem('user')).data;
			this.permission = ["6", "1", "9"].includes(user.user.roleId);
		},
		getSummaries() {
			this.$nextTick(() => {
				this.$refs['multipleTable'].doLayout();
				this.$refs['multipleTable2'].doLayout();
			});
			return this.list.summary;
		},
		// 过滤条件 更改
		handleFilter(key, val) {
			console.log(this.filter.date, '========eeeeeeeee')
			switch (key) {
				case 0:
					if (this.filter.date) {
						this.filter.hospitalTimeStart = dayjs(this.filter.date[0]).format('YYYY-MM-DD 00:00:00');
						this.filter.hospitalTimeEnd = dayjs(this.filter.date[1]).format('YYYY-MM-DD 23:59:59');
					} else {
						this.filter.hospitalTimeStart = '';
						this.filter.hospitalTimeEnd = '';
					}
					break;
				case 3:
					if (this.filter.finishdate) {
						this.filter.finishTimeStart = dayjs(this.filter.finishdate[0]).format('YYYY-MM-DD 00:00:00');
						this.filter.finishTimeEnd = dayjs(this.filter.finishdate[1]).format('YYYY-MM-DD 23:59:59');
					} else {
						this.filter.finishTimeStart = '';
						this.filter.finishTimeEnd = '';
					}
					break;
			}
			console.log(this.filter, '======ffffff')
			this.filter.pageNumber = 1;
			if (val || key == 4) {
				this.loadList();
			}
		},
		handleSizeChange(v) {
			this.filter.pageSize = v;
			this.filter.pageNumber = 1;
			this.loadList();
		},
		handleCurrentChange(v) {
			this.filter.pageNumber = v;
			this.loadList();
		},
		async exportExcel() {
			await this.loadExportData();

			const outdate = this.getExportDateSuffix();
			const filename = this.getExportFilename(outdate);

			utils.exportExcel(this.$refs.multipleTable2, 'sheet1', filename);
		},

		async loadExportData() {
			const originalPageSize = this.filter.pageSize;
			this.filter.pageSize = this.list.total;

			try {
				const res = await this.fetchData();

				if (res.code === 500) {
					return this.$router.push({
						name: 'Login',
						query: { r: location.href }
					});
				}

				if (res.code !== 1000) {
					this.$message.error(res.message);
					return;
				}

				this.list2.total = +res.total;
				this.list2.current = this.filter.pageNumber;
				this.list2.pageSize = Math.ceil(this.list2.total / this.filter.pageSize);
				this.list2.data = this.sortDataWithSummary(res.data.formResults);
				this.questionInfo = res.data.formItems;
			} finally {
				this.filter.pageSize = originalPageSize;
			}
		},

		getExportDateSuffix() {
			if (this.filter.date) {
				return ` 出院日期：${dayjs(this.filter.date[0]).format('YYYY-MM-DD')}~${dayjs(this.filter.date[1]).format('YYYY-MM-DD')}`;
			}
			return "";
		},

		getExportFilename(dateSuffix) {
			if (this.filter.dictId == 99) {
				return `问卷看板${dateSuffix}.xlsx`;
			} else {
				return `《${this.questionInfo.dictName}》汇总${dateSuffix}.xlsx`;
			}
		},
		getColumnWidth(item) {
			if (item.width) {
				return item.width === 'auto' ? undefined : item.width;
			} else {
				return 180;
			}
		},

		getSubColumnWidth(item) {
			if (item.width === 'auto') {
				return undefined;
			}

			return 180;
		},

		handleHeaderClick(item) {

			const query = {
				dictId: item.id,
				datasources: this.dataSources
			};

			if (this.filter.finishdate && this.filter.finishdate.length === 2) {
				query.finishdate = this.filter.finishdate.join(',');
			}

			if (this.filter.date && this.filter.date.length === 2) {
				query.date = [
					dayjs(this.filter.date[0]).format('YYYY-MM-DD'),
					dayjs(this.filter.date[1]).format('YYYY-MM-DD')
				].join(',');
			}
			this.$router.push({
				name: 'Statistics/QuestionnaireStatistics',
				query: query
			})

		},
		handleColumnClick(row, item) {
			console.log(item, '======iiii', row)
			const query = {
				dictId: item.id,
				datasources: this.dataSources,
				depId: row.depId,
			}

			// 传递填写日期参数
			if (this.filter.finishdate && this.filter.finishdate.length === 2) {
				query.finishdate = [
					dayjs(this.filter.finishdate[0]).format('YYYY-MM-DD'),
					dayjs(this.filter.finishdate[1]).format('YYYY-MM-DD')
				].join(',');
			}

			// 传递出院日期参数
			if (this.filter.date && this.filter.date.length === 2) {
				query.date = [
					dayjs(this.filter.date[0]).format('YYYY-MM-DD'),
					dayjs(this.filter.date[1]).format('YYYY-MM-DD')
				].join(',');
			}

			this.$router.push({
				name: 'Statistics/Questionnaire',
				query: query
			})
		},

	}
}
</script>

<style lang="less" scoped>
@import '@/assets/style/var';

// 可点击表头样式
.clickable-header {
	color: #699CE4;
	cursor: pointer;
	white-space: nowrap;
}
</style>